import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const CheckIcon = () => {
  return <FontAwesomeIcon icon={faCheck} />
}

export default CheckIcon
